import { BareModal } from '@cb/apricot-react'
import ScoreSendModalStarterContent from './ScoreSendModalStarterContent'
import ScoreSendModalOptOutContent from './ScoreSendModalOptOutContent'
import ScoreSendModalOptOutCompleteContent from './ScoreSendModalOptOutCompleteContent'
import {
  useUserDetailsQuery,
  useEducationPeriodsQuery,
  useDeadlinesQuery,
  useAnalyticsStudentScoreSendOptOutEvent,
} from '../../hooks'

function PromptForScoreSendActionModal() {
  const [shouldCloseModal, setShouldCloseModal] = useState(false)
  const [currentStep, setCurrentStep] = useState(0)
  // User Details
  const {
    data: userDetails = {},
    isLoading: isLoadingUserDetails,
  } = useUserDetailsQuery()
  const { studentId } = userDetails
  // Education Periods
  const {
    data: educationPeriodsData = {},
    isLoading: isLoadingEducationPeriods,
  } = useEducationPeriodsQuery({ id: studentId, myDetailsComplete: !isLoadingUserDetails })
  const { currentEducationPeriod = {} } = educationPeriodsData
  // Deadlines
  const {
    data: deadlinesData,
  } = useDeadlinesQuery({
    educationPeriodCd: currentEducationPeriod?.code,
    educationPeriodsComplete: !isLoadingEducationPeriods,
  })

  useAnalyticsStudentScoreSendOptOutEvent({ step: currentStep })

  let ModalContentComponent

  switch (currentStep) {
    case 1:
      ModalContentComponent = ScoreSendModalOptOutContent
      break

    case 2:
      ModalContentComponent = ScoreSendModalOptOutCompleteContent
      break

    default:
      ModalContentComponent = ScoreSendModalStarterContent
  }
  return (
    <BareModal
      open={!shouldCloseModal}
      clickOverlayToClose={false}
      escClose={false}
      shadowRoot
      modalNode
    >
      <ModalContentComponent
        nextStepFunc={setCurrentStep}
        setShouldCloseModal={setShouldCloseModal}
        studentId={userDetails.studentId}
        educationPeriodCd={currentEducationPeriod.code}
        diSelectionEndDate={deadlinesData?.diSelectionEndDate}
      />
    </BareModal>
  )
}

export default PromptForScoreSendActionModal
